module.exports = __webpack_public_path__ + "static/media/banner_slide_2.153d578b.jpg";